import React from 'react'
import Head from 'next/head'
import { useIntl } from 'react-intl'

import ForgotPasswordRoute from '../../../../routes/ForgotPassword'

const ForgotPassword = () => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'FORGOT_PASSWORD',
            defaultMessage: 'Forgot Password',
          })}
        </title>
      </Head>
      <ForgotPasswordRoute />
    </React.Fragment>
  )
}

export default ForgotPassword
